import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5001';

let socket = null;

// Son de notification simple (tone court)
const playNotificationSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.value = 800; // Fréquence en Hz
    oscillator.type = 'sine';

    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.3);
  } catch (e) {
    // Silencieux si audio non supporté
  }
};

export const connectSocket = (token) => {
  if (socket?.connected) return socket;

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling']
  });

  socket.on('connect', () => {
    console.log('🔌 Socket connected:', socket.id);
  });

  socket.on('disconnect', () => {
    console.log('🔌 Socket disconnected');
  });

  socket.on('connect_error', (error) => {
    console.error('🔌 Socket connection error:', error.message);
  });

  // Jouer un son quand de nouvelles suggestions arrivent
  socket.on('new_suggestions', () => {
    playNotificationSound();
  });

  // Jouer un son quand un trade démarre
  socket.on('trades_started', () => {
    playNotificationSound();
  });

  // Jouer un son quand un trade est complété
  socket.on('trades_updated', () => {
    playNotificationSound();
  });

  // Jouer un son quand un nouveau message arrive
  socket.on('new_message_for_user', () => {
    playNotificationSound();
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;

// Écouter les mises à jour de prix
export const onPriceUpdate = (callback) => {
  if (socket) {
    socket.on('price_update', callback);
  }
};

// Écouter les nouvelles recommandations
export const onNewRecommendation = (callback) => {
  if (socket) {
    socket.on('new_recommendation', callback);
  }
};

// Écouter les trades exécutés
export const onTradeExecuted = (callback) => {
  if (socket) {
    socket.on('trade_executed', callback);
  }
};

// Écouter les nouveaux messages (pour l'utilisateur)
export const onNewMessage = (callback) => {
  if (socket) {
    socket.on('new_message_for_user', callback);
  }
};

// Écouter quand l'admin a lu les messages (pour l'utilisateur)
export const onMessagesRead = (callback) => {
  if (socket) {
    socket.on('messages_read', callback);
  }
};

// Écouter les nouveaux messages support (pour l'admin)
export const onNewSupportMessage = (callback) => {
  if (socket) {
    socket.on('new_support_message', callback);
  }
};

// Écouter les nouveaux utilisateurs inscrits (pour l'admin)
export const onNewUserRegistered = (callback) => {
  if (socket) {
    socket.on('new_user_registered', callback);
  }
};

// Écouter la confirmation de lecture par l'utilisateur (pour l'admin)
export const onUserReadMessages = (callback) => {
  if (socket) {
    socket.on('user_read_messages', callback);
  }
};

// Écouter les soumissions de TXID de dépôt (pour l'admin, temps réel)
export const onDepositTxidSubmitted = (callback) => {
  if (socket) {
    socket.on('deposit_txid_submitted', callback);
  }
};

// Admin: nouvelle demande de retrait (trading ou épargne)
export const onWithdrawalCreated = (callback) => {
  if (socket) {
    socket.on('withdrawal_created', callback);
  }
};

// Admin: nouvelle soumission KYC
export const onKycSubmitted = (callback) => {
  if (socket) {
    socket.on('kyc_submitted', callback);
  }
};

// Écouter les mises à jour de statut d'un dépôt TXID (pour l'utilisateur)
export const onDepositTxidUpdated = (callback) => {
  if (socket) {
    socket.on('deposit_txid_updated', callback);
  }
};

// Écouter les mises à jour de statut de l'adresse de retrait (pour l'utilisateur)
export const onWithdrawalAddressUpdated = (callback) => {
  if (socket) {
    socket.on('withdrawal_address_updated', callback);
  }
};

// Écouter les nouvelles suggestions (temps réel, pour rafraîchir la page Trading)
export const onNewSuggestions = (callback) => {
  if (socket) {
    socket.on('new_suggestions', callback);
  }
};

// Écouter la mise à jour des trades (clôture / gains versés)
export const onTradesUpdated = (callback) => {
  if (socket) {
    socket.on('trades_updated', callback);
  }
};

// Écouter le démarrage des trades programmés
export const onTradesStarted = (callback) => {
  if (socket) {
    socket.on('trades_started', callback);
  }
};

// Retirer un listener (tous les handlers de l'événement)
export const offEvent = (event) => {
  if (socket) {
    socket.off(event);
  }
};

// Retirer UN handler spécifique (préserve les autres, ex: le son)
export const offEventHandler = (event, callback) => {
  if (socket) {
    socket.off(event, callback);
  }
};

export default {
  connectSocket,
  disconnectSocket,
  getSocket,
  onPriceUpdate,
  onNewRecommendation,
  onTradeExecuted,
  offEvent
};
